module.exports = __webpack_public_path__ + "img/mappa-totem-0-small.188bdf0d.jpg";